import { PrestacionReferencia } from "../domain/entities/prestacionReferencia";
import { ProtocoloService } from "../domain/services/protocoloService";

export class GetPrestacionReferencia {
  constructor(private protocoloService: ProtocoloService) {}

  async execute(
    idPrestación: number,
    token: string
  ): Promise<PrestacionReferencia[]> {
    const colPrestaciones: PrestacionReferencia[] =
      await this.protocoloService.getPrestacionReferencia(idPrestación, token);
    return colPrestaciones;
  }
}
